import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const SIMPLEHEADERTEXTITEMBLOCK_LEGACY_FIELD_ORDER = [
  "text",
  "link_url",
  "link_target",
  "text_color",
  "active_text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  simpleHeaderTextItemBlockDescriptor: _generatedSimpleHeaderTextItemBlockDescriptor,
  simpleHeaderTextItemBlockBlocDefinition,
  simpleHeaderTextItemBlockDashboardLayout,
  simpleHeaderTextItemBlockConfig,
  simpleHeaderTextItemBlockResolveConfig,
  simpleHeaderTextItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Text item",
    componentType: "SimpleHeaderTextItemBlockComponent",
    category: "navigation",
    description: "Text item.",
    keywords: [],
    allowedIn: [
      { bloc: "SimpleHeaderBlockComponent", slot: "left_items" },
      { bloc: "SimpleHeaderBlockComponent", slot: "middle_items" },
      { bloc: "SimpleHeaderBlockComponent", slot: "right_items" },
    ],
    sharedFields: {},
  },

  () => ({
    text: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.simple-header-text-item.text.label",
      },
    }),
    link_url: propertyValue({
      type: "link",
      value: "",
      options: {
        label: "pages.blocks.simple-header-text-item.link-url.label",
      },
    }),
    link_target: propertyValue({
      type: "select",
      value: "_self",
      options: {
        label: "pages.blocks.simple-header-text-item.link-target.label",
        choices: [
          {
            value: "_self",
            label: "pages.blocks.simple-header-text-item.link-target.options.self",
          },
          {
            value: "_blank",
            label: "pages.blocks.simple-header-text-item.link-target.options.blank",
          },
        ],
      },
    }),
    text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-600" },
      options: {
        label: "pages.blocks.simple-header-text-item.text-color.label",
      },
    }),
    active_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-800" },
      options: {
        label: "pages.blocks.simple-header-text-item.active-text-color.label",
        help: "pages.blocks.simple-header-text-item.active-text-color.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.simple-header-text-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.simple-header-text-item.fieldset.link.label",
            fields: [
              "text",
              "link_url",
              "link_target",
              "text_color",
              "active_text_color",
            ],
          },
        ],
      },
    ],
  }),
);

export function simpleHeaderTextItemBlockDescriptor(): IBlockDescriptor;
export function simpleHeaderTextItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function simpleHeaderTextItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSimpleHeaderTextItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedSimpleHeaderTextItemBlockDescriptor,
    simpleHeaderTextItemBlockProperties,
    fieldOrder,
  );
}

export {
  simpleHeaderTextItemBlockBlocDefinition,
  simpleHeaderTextItemBlockDashboardLayout,
  simpleHeaderTextItemBlockProperties,
  simpleHeaderTextItemBlockConfig,
  simpleHeaderTextItemBlockResolveConfig,
};

export type SimpleHeaderTextItemBlockConfig = typeof simpleHeaderTextItemBlockConfig;
